import React, { Component } from 'react';
import { Icon, Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';

const styles = theme => ({
    layoutRoot: {},
});

class StudentProgress extends Component {

    handleEventClick = (event) => {
        if (event.ProgressBlockColor === '#3D9970') {
            return this.props.history.push(`/${event.EventType.toLowerCase()}/grader/${event.StudentEventID}`)
        }
        else return null
    }

    render() {
        const completedRow = (green, red) => {
            let total = green + red;
            let percent = (green / total) * 100
            return Math.round(percent) + '%'
        }

        const toGradebookRow = (row) => {
            if (this.props.auth.user.role === 'instructor') {
                if (row.authCanViewGradebook) {
                    return (
                        <IconButton
                            onClick={() => this.props.history.push(`/gradebook/student/event_list/${row.company_calendar_course_id}/${this.props.student.student_id}`)}
                        >
                            <Icon>arrow_right_alt</Icon>
                        </IconButton>
                    )
                }
            }
            else if (this.props.auth.user.role != 'instructor') {
                return (
                    <IconButton
                        onClick={() => this.props.history.push(`/gradebook/student/event_list/${row.company_calendar_course_id}/${this.props.student.student_id}`)}
                    >
                        <Icon>arrow_right_alt</Icon>
                    </IconButton>
                )
            }
            return null
        }

        const eventGrid = (events) => {
            let blocks = events.map(e => {
                return (
                    <Tooltip key={e.company_calendar_event_id} title={
                        <React.Fragment>
                            <div>{e.EventName}</div>
                            <div>{e.unscheduled ? 'Self-Paced' : e.EventDate}</div>
                            <div>{e.EventStatus}</div>
                            <div>{Number(e.EventScore).toFixed(1)}</div>
                        </React.Fragment>
                    }
                        placement="top"
                    >
                        {/* border: `2px solid ${e.EventColor}` */}
                        <div
                            onClick={() => this.handleEventClick(e)}
                            style={{ backgroundColor: e.ProgressBlockColor, height: '25px', width: '25px', margin: '5px', float: 'left', cursor: e.ProgressBlockColor === '#3D9970' ? 'pointer' : 'default' }}>
                        </div>
                    </Tooltip>

                )
            })
            return (
                <div>{blocks}</div>
            )
        }

        const tableRows = this.props.progress.map(row => {
            const colors = {
                green: "#3D9970",
                red: "#FF4136",
                grey: "#AAAAAA"
            };

            const data = row.Events.reduce((pre, cur) => {
                const blockColor = cur.ProgressBlockColor;
                if (blockColor === colors.green) pre.pass++;
                if (blockColor === colors.red) pre.fail++;
                return pre;
            }, { fail: 0, pass: 0 });

            const totalPercent = Math.round((data.pass + data.fail) / row.Events.length);

            return (
                <React.Fragment key={row.company_calendar_course_id}>
                    <TableRow key={row.company_calendar_course_id}>
                        <TableCell>{row.CourseName}</TableCell>
                        <TableCell>{`${totalPercent}%`}</TableCell>
                        <TableCell>{eventGrid(row.Events)}</TableCell>
                        <TableCell>{row.TotalGrade}</TableCell>
                        <TableCell>
                            {toGradebookRow(row)}
                        </TableCell>
                    </TableRow>
                </React.Fragment>
            )
        })

        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Course Name</TableCell>
                        <TableCell>Complete</TableCell>
                        <TableCell>
                            {/* Events */}
                            <div
                                style={{ backgroundColor: '#FF4136', height: '25px', width: '25px', margin: '5px', float: 'left' }}>
                            </div>
                            <div
                                style={{float: 'left', margin: '5px', paddingTop: '5px' }}>Fail/Retake
                            </div>
                            <div
                                style={{ backgroundColor: '#FF851B', height: '25px', width: '25px', margin: '5px', float: 'left' }}>
                            </div>
                            <div
                                style={{float: 'left', margin: '5px', paddingTop: '5px' }}>Not Started/Late
                            </div>
                            <div
                                style={{ backgroundColor: '#FFDC00', height: '25px', width: '25px', margin: '5px', float: 'left' }}>
                            </div>
                            <div
                                style={{float: 'left', margin: '5px', paddingTop: '5px' }}>Not Submitted/Late
                            </div>
                            <div
                                style={{ backgroundColor: '#3D9970', height: '25px', width: '25px', margin: '5px', float: 'left' }}>
                            </div>
                            <div
                                style={{float: 'left', margin: '5px', paddingTop: '5px' }}>Completed
                            </div>
                            <div
                                style={{ backgroundColor: '#AAAAAA', height: '25px', width: '25px', margin: '5px', float: 'left' }}>
                            </div>
                            <div
                                style={{float: 'left', margin: '5px', paddingTop: '5px' }}>Future Event
                            </div>
                        </TableCell>
                        <TableCell>Course Grade</TableCell>
                        <TableCell>To Gradebook</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableRows}
                </TableBody>
            </Table>
        );
    }

}

export default (StudentProgress);


// WEBPACK FOOTER //
// src/main/content/student/StudentProgress.js